import * as React from "react"

const SvgComponent = (props) => (
    <svg id={"bar"} xmlns="http://www.w3.org/2000/svg" width={81} height={10} {...props} viewBox={'0 0 81 10'}>
        <path data-name="Rectangle 59" fill="#f72585" d="M0 0h28v10H0z" />
        <path data-name="Rectangle 60" fill="#7209b7" d="M12 0h28v10H12z" />
        <path data-name="Rectangle 61" fill="#3a0ca3" d="M30 0h28v10H30z" />
        <path data-name="Rectangle 62" fill="#4895ef" d="M41 0h28v10H41z" />
        <path data-name="Rectangle 63" fill="#b5179e" d="M12 0h28v10H12z" />
        <path data-name="Rectangle 64" fill="#480ca8" d="M24 0h28v10H24z" />
        <path data-name="Rectangle 65" fill="#4361ee" d="M41 0h28v10H41z" />
        <path data-name="Rectangle 66" fill="#560bad" d="M18 0h28v10H18z" />
        <path data-name="Rectangle 67" fill="#3f37c9" d="M35 0h28v10H35z" />
        <path data-name="Rectangle 68" fill="#4cc9f0" d="M53 0h28v10H53z" />
    </svg>
)

export default SvgComponent
